import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { SxProps, useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { timeoutDialogSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { setTimeoutDialog } from "../../../store/helpers/helperReducers";
import { logout } from "../../../store/api/auth/reducer";
import { Button } from "../../ui/button";

interface ITimeoutDialog {
  children?: React.ReactNode;
  actionName?: string;
  handleClickAction: (arg: string) => void;
}

const TimeoutDialog: React.FC<ITimeoutDialog> = ({ children, handleClickAction, actionName = "staySignedIn" }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useStoreDispatch();
  const openTimeoutDialog = useSelector(timeoutDialogSelector) || false;

  const handlerAction = (e: any) => {
    e.preventDefault();
    dispatch(setTimeoutDialog(false));
    handleClickAction(e.target?.name);
  };

  const handleClose = (e: any) => {
    dispatch(setTimeoutDialog(false));
    handleClickAction(e.target?.name);
    dispatch(logout())
  };

  const dialogSxProps: SxProps = {
    "& .MuiPaper-root.MuiDialog-paper": {
      padding: "12px",
      backgroundColor: "var(--card)",
      color: "var(--foreground)",
    },
  };
  return (
    <Dialog
      sx={dialogSxProps}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      open={openTimeoutDialog}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle>
        <IconButton
          aria-label="close"
          name="cancel"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "var(--muted-foreground)",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography component={"p"}>
          Your session is about to expire in 2 minutes.
        </Typography>
        <Typography component={"p"}>
          Do you want to stay signed in?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button name="signOutNow" variant="secondary" autoFocus onClick={handleClose}>
          Logout now
        </Button>
        <Button name={actionName.toLowerCase()} variant="default" autoFocus onClick={handlerAction}>
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeoutDialog;
